var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content bg-white" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-2" }, [
      _c(
        "div",
        { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
        [
          _c("v-select", {
            attrs: {
              options: _vm.isTestOptions,
              searchable: false,
              clearable: false,
              placeholder: "Тест"
            },
            model: {
              value: _vm.isTest,
              callback: function($$v) {
                _vm.isTest = $$v
              },
              expression: "isTest"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          key: _vm.dateRange,
          staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2"
        },
        [
          _vm.isXl
            ? _c(
                "b-button-group",
                { staticClass: "datePickerXl" },
                [
                  _c("date-range-picker", {
                    ref: "picker",
                    attrs: {
                      "locale-data": _vm.dateRangeLocalFormat,
                      opens: "right",
                      ranges: _vm.dateRanges
                    },
                    on: {
                      update: function($event) {
                        return _vm.selectRange($event)
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "input",
                          fn: function(picker) {
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm._f("formatDateRange")(
                                      _vm.range.startDate
                                    )
                                  ) +
                                  " - " +
                                  _vm._s(
                                    _vm._f("formatDateRange")(_vm.range.endDate)
                                  ) +
                                  "\n                    "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3800565667
                    ),
                    model: {
                      value: _vm.range,
                      callback: function($$v) {
                        _vm.range = $$v
                      },
                      expression: "range"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    { attrs: { size: "sm", variant: "primary" } },
                    [
                      _c("i", {
                        staticClass: "icon-fa icon-fa-calendar-check-o"
                      })
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isXl
            ? _c(
                "b-input-group",
                { key: _vm.dateRange },
                [
                  _c("div"),
                  _vm._v(" "),
                  _c(
                    "b-input-group-append",
                    [
                      _c("datepicker", {
                        staticClass: "date dateLeft",
                        attrs: {
                          "input-class": "form-control dateFrom",
                          size: "sm",
                          "monday-first": "",
                          language: _vm.ru,
                          placeholder: "С:"
                        },
                        model: {
                          value: _vm.range.startDate,
                          callback: function($$v) {
                            _vm.$set(_vm.range, "startDate", $$v)
                          },
                          expression: "range.startDate"
                        }
                      }),
                      _vm._v(" "),
                      _c("datepicker", {
                        staticClass: "date dateRight",
                        attrs: {
                          "input-class": "form-control dateTo",
                          "monday-first": "",
                          size: "sm",
                          language: _vm.ru,
                          placeholder: "По:"
                        },
                        model: {
                          value: _vm.range.endDate,
                          callback: function($$v) {
                            _vm.$set(_vm.range, "endDate", $$v)
                          },
                          expression: "range.endDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
        [
          _c(
            "v-select",
            {
              attrs: {
                options: _vm.selectOffers,
                filter: _vm.filterOffers,
                required: "",
                label: "title",
                placeholder: "Оффер",
                multiple: ""
              },
              scopedSlots: _vm._u([
                {
                  key: "option",
                  fn: function(option) {
                    return [
                      _c("span", [
                        _vm._v(
                          "(" + _vm._s(option.id) + ") " + _vm._s(option.title)
                        )
                      ])
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.search,
                callback: function($$v) {
                  _vm.search = $$v
                },
                expression: "search"
              }
            },
            [
              _c(
                "span",
                { attrs: { slot: "no-options" }, slot: "no-options" },
                [_vm._v("Совпадений не найдено.")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
        [
          _c(
            "v-select",
            {
              attrs: {
                options: _vm.sources,
                required: "",
                label: "title",
                placeholder: "Источник",
                multiple: ""
              },
              model: {
                value: _vm.source,
                callback: function($$v) {
                  _vm.source = $$v
                },
                expression: "source"
              }
            },
            [
              _c(
                "span",
                { attrs: { slot: "no-options" }, slot: "no-options" },
                [_vm._v("Совпадений не найдено.")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
        [
          _c(
            "v-select",
            {
              attrs: {
                options: _vm.groups,
                required: "",
                placeholder: "Группа",
                multiple: ""
              },
              model: {
                value: _vm.group,
                callback: function($$v) {
                  _vm.group = $$v
                },
                expression: "group"
              }
            },
            [
              _c(
                "span",
                { attrs: { slot: "no-options" }, slot: "no-options" },
                [_vm._v("Совпадений не найдено.")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.$currentUser.role == "admin" || _vm.$currentUser.role == "leader"
        ? _c(
            "div",
            { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
            [
              _c(
                "v-select",
                {
                  attrs: {
                    label: "name",
                    options: _vm.users,
                    required: "",
                    placeholder: "Медиабайер",
                    multiple: ""
                  },
                  model: {
                    value: _vm.user,
                    callback: function($$v) {
                      _vm.user = $$v
                    },
                    expression: "user"
                  }
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "no-options" }, slot: "no-options" },
                    [_vm._v("Совпадений не найдено.")]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.$currentUser.department === "adkey"
        ? _c(
            "div",
            { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
            [
              _c("v-select", {
                attrs: {
                  options: _vm.applicationOwnerOptions,
                  placeholder: "Приложение",
                  clearable: false,
                  searchable: false
                },
                model: {
                  value: _vm.application_owner,
                  callback: function($$v) {
                    _vm.application_owner = $$v
                  },
                  expression: "application_owner"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
        [
          _c("v-select", {
            attrs: {
              options: _vm.types,
              placeholder: "Тип",
              clearable: false,
              searchable: false,
              multiple: ""
            },
            model: {
              value: _vm.type,
              callback: function($$v) {
                _vm.type = $$v
              },
              expression: "type"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.$currentUser.role != "user"
        ? _c(
            "div",
            { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
            [
              _c(
                "v-select",
                {
                  attrs: {
                    id: "account_manager",
                    label: "name",
                    placeholder: "Аккаунт",
                    options: _vm.accountManagers,
                    reduce: function(accountManager) {
                      return accountManager.id
                    },
                    multiple: ""
                  },
                  model: {
                    value: _vm.account,
                    callback: function($$v) {
                      _vm.account = $$v
                    },
                    expression: "account"
                  }
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "no-options" }, slot: "no-options" },
                    [_vm._v("Совпадений не найдено.")]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
        [
          _c(
            "v-select",
            {
              attrs: {
                placeholder: "Сейл",
                label: "name",
                options: _vm.salesManagers,
                reduce: function(manager) {
                  return manager.id
                },
                required: "",
                multiple: ""
              },
              model: {
                value: _vm.filters.salesManagers,
                callback: function($$v) {
                  _vm.$set(_vm.filters, "salesManagers", $$v)
                },
                expression: "filters.salesManagers"
              }
            },
            [
              _c(
                "span",
                { attrs: { slot: "no-options" }, slot: "no-options" },
                [_vm._v("Совпадений не найдено.")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
        [
          _c(
            "v-select",
            {
              attrs: {
                options: _vm.advertisers,
                placeholder: "Рекламодатель",
                reduce: function(advertiser) {
                  return advertiser.value
                },
                required: "",
                multiple: ""
              },
              model: {
                value: _vm.filters.advertisers,
                callback: function($$v) {
                  _vm.$set(_vm.filters, "advertisers", $$v)
                },
                expression: "filters.advertisers"
              }
            },
            [
              _c(
                "span",
                { attrs: { slot: "no-options" }, slot: "no-options" },
                [_vm._v("Совпадений не найдено.")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
        [
          _c("v-select", {
            attrs: {
              options: _vm.channels,
              placeholder: "Канал продаж",
              clearable: false,
              searchable: false,
              reduce: function(channel) {
                return channel.value
              },
              multiple: ""
            },
            model: {
              value: _vm.channel,
              callback: function($$v) {
                _vm.channel = $$v
              },
              expression: "channel"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
        [
          _c("v-select", {
            attrs: {
              options: _vm.sub4Options,
              placeholder: "Subid-4",
              label: "text",
              clearable: false,
              searchable: false
            },
            model: {
              value: _vm.selectedSub4,
              callback: function($$v) {
                _vm.selectedSub4 = $$v
              },
              expression: "selectedSub4"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2" },
        [
          _c(
            "v-select",
            {
              staticClass: "geoComponent",
              attrs: {
                label: "name",
                options: _vm.geo,
                size: "sm",
                required: "",
                placeholder: "ГЕО",
                multiple: ""
              },
              model: {
                value: _vm.selectedGeo,
                callback: function($$v) {
                  _vm.selectedGeo = $$v
                },
                expression: "selectedGeo"
              }
            },
            [
              _c(
                "span",
                { attrs: { slot: "no-options" }, slot: "no-options" },
                [_vm._v("Совпадений не найдено.")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
        [
          _c("v-select", {
            attrs: {
              options: _vm.userGroups,
              label: "title",
              placeholder: "Группа пользователей",
              clearable: false,
              searchable: false,
              reduce: function(userGroup) {
                return userGroup.id
              },
              multiple: ""
            },
            model: {
              value: _vm.selectedUserGroups,
              callback: function($$v) {
                _vm.selectedUserGroups = $$v
              },
              expression: "selectedUserGroups"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-2" }, [
      _c(
        "div",
        { staticClass: "col-sm-5 col-md-3 col-lg-3 col-xl-2 mb-2 applyButton" },
        [
          _c(
            "b-input-group",
            [
              _c("div"),
              _vm._v(" "),
              _c(
                "b-input-group-append",
                [
                  _c(
                    "b-btn",
                    {
                      staticClass: "mainButton",
                      staticStyle: {
                        "margin-right": "4px",
                        "border-top-left-radius": "0.2rem",
                        "border-bottom-left-radius": "0.2rem"
                      },
                      attrs: { size: "sm", text: "Search", variant: "success" },
                      on: {
                        click: function($event) {
                          return _vm.getReports(
                            1,
                            { sortBy: _vm.sortBy, sortDesc: _vm.sortDesc },
                            _vm.user,
                            _vm.search,
                            true
                          )
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                        Применить\n                        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      staticClass: "mainButton",
                      attrs: { size: "sm", variant: "outline-danger" },
                      on: { click: _vm.resetFilters }
                    },
                    [_vm._v("Очистить\n                        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-2 col-md-6 col-lg-6 col-xl-8 mb-2" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-5 col-md-3 col-lg-3 col-xl-2 mb-2 applyButton" },
        [
          _c("b-button-group", { staticClass: "float-right mainButton" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-outline-success btn-sm",
                attrs: { href: _vm.getExcelParamsString("xlsx") }
              },
              [_vm._v("Excel")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-outline-success btn-sm",
                attrs: { href: _vm.getExcelParamsString("csv") }
              },
              [_vm._v("CSV")]
            )
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        !_vm.isMobile
          ? _c(
              "div",
              [
                _c(
                  "b-table",
                  {
                    attrs: {
                      hover: "",
                      responsive: "",
                      bordered: "",
                      small: "",
                      items: _vm.reports,
                      fields: _vm.fields,
                      "no-local-sorting": "",
                      "sort-by": _vm.sortBy,
                      busy: _vm.isBusy,
                      "sort-desc": _vm.sortDesc,
                      "sort-direction": _vm.sortDirection
                    },
                    on: {
                      "update:sortBy": function($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function($event) {
                        _vm.sortBy = $event
                      },
                      "sort-changed": function($event) {
                        return _vm.getReports(1, $event, _vm.user, _vm.search)
                      },
                      "update:sortDesc": function($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function($event) {
                        _vm.sortDesc = $event
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "roi",
                          fn: function(row) {
                            return [
                              row.item.roi !== null
                                ? _c("div", [_vm._v(_vm._s(row.item.roi))])
                                : _vm._e(),
                              _vm._v(" "),
                              row.item.roi === null
                                ? _c("div", [_vm._v("0.00")])
                                : _vm._e()
                            ]
                          }
                        },
                        {
                          key: "gm_rev",
                          fn: function(row) {
                            return [
                              row.item.gm_rev !== null
                                ? _c("div", [_vm._v(_vm._s(row.item.gm_rev))])
                                : _vm._e(),
                              _vm._v(" "),
                              row.item.gm_rev === null
                                ? _c("div", [_vm._v("0.00")])
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      691680329
                    )
                  },
                  [
                    _c("template", { slot: "table-busy" }, [
                      _c(
                        "div",
                        { staticClass: "text-center text-danger my-2" },
                        [
                          _c("b-spinner", { staticClass: "align-middle" }),
                          _vm._v(" "),
                          _c("strong", [_vm._v("Загрузка...")])
                        ],
                        1
                      )
                    ])
                  ],
                  2
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isMobile
          ? _c(
              "div",
              [
                _c(
                  "b-table",
                  {
                    attrs: {
                      hover: "",
                      responsive: "",
                      bordered: "",
                      stacked: "",
                      small: "",
                      items: _vm.reports,
                      busy: _vm.isBusy,
                      fields: _vm.fields,
                      "no-local-sorting": "",
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                      "sort-direction": _vm.sortDirection
                    },
                    on: {
                      "update:sortBy": function($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function($event) {
                        _vm.sortBy = $event
                      },
                      "sort-changed": function($event) {
                        return _vm.getReports(1, $event, _vm.user, _vm.search)
                      },
                      "update:sortDesc": function($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function($event) {
                        _vm.sortDesc = $event
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "roi",
                          fn: function(row) {
                            return [
                              row.item.roi !== null
                                ? _c("div", [_vm._v(_vm._s(row.item.roi))])
                                : _vm._e(),
                              _vm._v(" "),
                              row.item.roi === null
                                ? _c("div", [_vm._v("0.00")])
                                : _vm._e()
                            ]
                          }
                        },
                        {
                          key: "gm_rev",
                          fn: function(row) {
                            return [
                              row.item.gm_rev !== null
                                ? _c("div", [_vm._v(_vm._s(row.item.gm_rev))])
                                : _vm._e(),
                              _vm._v(" "),
                              row.item.gm_rev === null
                                ? _c("div", [_vm._v("0.00")])
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      691680329
                    )
                  },
                  [
                    _c("template", { slot: "table-busy" }, [
                      _c(
                        "div",
                        { staticClass: "text-center text-danger my-2" },
                        [
                          _c("b-spinner", { staticClass: "align-middle" }),
                          _vm._v(" "),
                          _c("strong", [_vm._v("Загрузка...")])
                        ],
                        1
                      )
                    ])
                  ],
                  2
                )
              ],
              1
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-6 col-sm-6" }, [
        _c(
          "div",
          { attrs: { role: "status", "aria-live": "polite" } },
          [
            _vm._v("Количество строк:\n                "),
            _c(
              "b-form-select",
              {
                staticStyle: { width: "70px" },
                attrs: { size: "sm" },
                on: {
                  change: function($event) {
                    return _vm.getReports()
                  }
                },
                model: {
                  value: _vm.pageSize,
                  callback: function($$v) {
                    _vm.pageSize = $$v
                  },
                  expression: "pageSize"
                }
              },
              [
                _c("option", { domProps: { value: 25 } }, [_vm._v("25")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 50 } }, [_vm._v("50")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 75 } }, [_vm._v("75")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 100 } }, [_vm._v("100")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 150 } }, [_vm._v("150")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 200 } }, [_vm._v("200")])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { attrs: { role: "status", "aria-live": "polite" } }, [
          _vm._v("Записей на странице: "),
          _vm.reports && _vm.reports.length
            ? _c("span", [_vm._v(_vm._s(_vm.reports.length - 2))])
            : _vm._e(),
          !_vm.reports ? _c("span", [_vm._v("0")]) : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { attrs: { role: "status", "aria-live": "polite" } }, [
          _vm._v("Всего записей: "),
          _vm.pager && _vm.pager.total
            ? _c("span", [_vm._v(_vm._s(_vm.pager.total))])
            : _vm._e(),
          !_vm.pager || !_vm.pager.total ? _c("span", [_vm._v("0")]) : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-6" }, [
        _c("div", { staticClass: "float-right" }, [
          _c("nav", { attrs: { "aria-label": "Page navigation" } }, [
            _c(
              "ul",
              { staticClass: "pagination justify-content-center" },
              [
                _c("b-pagination", {
                  attrs: {
                    size: "sm",
                    "total-rows": _vm.pager.total,
                    "per-page": _vm.pager.per_page
                  },
                  on: {
                    change: function($event) {
                      return _vm.getReports(
                        $event,
                        { sortBy: _vm.sortBy, sortDesc: _vm.sortDesc },
                        _vm.user,
                        _vm.search
                      )
                    }
                  },
                  model: {
                    value: _vm.pager.current_page,
                    callback: function($$v) {
                      _vm.$set(_vm.pager, "current_page", $$v)
                    },
                    expression: "pager.current_page"
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Отчёт по офферам")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e1252b0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e1252b0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/OffersReport.vue
// module id = 994
// module chunks = 0